const SegnalazioneMockInCompilazione = {
    "identitaSegnalante": {
        "persFisicaSegnalante": {
            "nome": "Alessandra",
            "cognome": "Cailli",
            "posPrezzoSegnalante": "",
            "numTelefono1": "099898724024",
        },
        "datiAnagraficiSegnalante": {
            "nomeSoggettoSegnalante": "Alessandra Cailli",
            "tipoSoggettoSegnalante": "Internalizzatore sistematico",
            "formaGiuridica": "S.r.l.",
            "codiceLEI": "",
            "via": "Via col Vento",
            "numCivico": "96",
            "codPostale": "00666",
            "nazione": "Italy",
            "regione": "Lazio",
            "provincia": "Roma"
        },
        "vesteSegnalante": {
            "vesteSegnalante": "Conto Terzi",
            "catTipologiaNegoziazione": "Market Making",
            "catTipologiaStrumNegoziato": "Derivati",
            "relazioneConSoggSegnalato": ""
        },
        "referenteRichiestaMaggioriInfo": [
            {
                "nomeReferente": "Marco",
                "cognomeReferente": "Giardina",
                "indirizzoMailReferente": "marcogiardina@giardinamarco.com",
                "posizioneReferente" : "posizione",
                "numCellulare": "2387239487",
                "numTelefono": "099898698624"
            }
        ]
    },
    "ordineOperazione": {
        "descrStrumFinanziario": [
            {
                "descrOperSospette": "Operazione molto sospetta",
                "nomeCompletoODesc": "Operazione tanto sospetta",
                "codiceIdentificativo": "695984651",
                "tipoCodiceCFI": "Si",
                "tipoDerivatoOTC": "OTC",
                "importoNominale": "sI",
                "valutaDenominazionePrezzo": "500 EURO",
                "dataScadenza": "2022-02-04",
                "premio": "600 euro",
                "tassoInteresse": "40 euro",
                "margine": "300",
                "pagamentoAnticipato": "SI",
                "dimensione": "",
                "valoreNominale": "",
                "prezzoEsercizio": "",
                "condizioneContrattuali": "",
                "nomeCompleto": "",
                "codIdentificatoSottostante": "",
                "tipoCodiceCFISottostante": "",
                "nomeSedeNegoziazione": "",
                "codiceSedeNegoziazione": "",
                "fuoriSede": ""
            }
        ],
        "dataOraOrdine": [
            {
                "dataInizio": "2022-02-17",
                "oraInizio": "18:00",
                "dataFine": "2022-02-22",
                "oraFine": "09:00",
                "fusoOrario": ""
            }
        ],
        "nazione": [
            {
                "nomeCodiceStatoDoveImpartitoOrdine": "Andorra",
                "nomeCodiceStatoDoveEseguitoOrdine": "Andorra"
            }
        ],
        "descrizioneOrdine": [
            {
                "numeroRiferimentoOrdine": "600",
                "dataRegolamento": "2022-02-11",
                "oraRegolamento": "14:0",
                "prezzoAcquistoVendita": "600",
                "volumeQuantitaStrumentiFinanziari": "3",
                "tipoOrdine": "Ordine",
                "modalitaInoltroOrdine": "",
                "oraInoltroOrdine": "13:0",
                "identitaPersonaCheInoltraOrdine": "Marco Giardina",
                "identitaPersonaCheRiceveOrdine": "Alessandra Cailli",
                "mezzoTrasmissioneOrdine": "POS",
                "oraModificaCancellazione": "05:00",
                "identitaPersonaCheCancellaOrdine": "Daniele Zennaro",
                "naturaDellaModifica": "Naturale",
                "mezzoPerModificaOrdine": "Bancomat"
            }
        ]
    },
    "descrizioneNaturaSospetto": {
        "naturaSospetto": {
            "natura": "Insider trading & Manipolazione"
        },
        "motiviSospetto": {
            "motiviSospetto": ""
        }
    },
    "identitaDelSospettato": {
        "informazioniPersonali": [
            {
                "nome": "Alessandra",
                "cognome": "Cailli",
                "dataNascita": "2022-02-04",
                "via": "Via col Vento",
                "numeroCivico": "50",
                "codicePostale": "00666",
                "localita": "Roma",
                "regione": "Lazio",
                "provincia": "Roma",
                "nazione": "Italy",
                "luogo": "Roma",
                "posizione": "Ferma",
                "numeroConto": "56",
                "identificativoCliente": "65",
                "relazioneConEmittenteStrumFinanziari": "No",
                "posizioneSospettato": "Ferma",
                "naturaInterventoSospettato": "Naturale",
                "entitaPortafoglioSospettato": "Portafoglio",
                "dataInizioRelazioneProfessionale": "2022-02-10",
                "tipoAttivitaUnitaNegozazione": "Negoziazione",
                "modelliNegoziazioneSospettato": "Modello",
                "nomeAltriSoggettiImplicati": "Marco Giardina",
                "attivitaAltriSoggettiImplicati": "GA"
            }
        ]
    },
    "informazioniSupplementariGenerali": {
        "informazioniSupplementari": {
            "noteAggiuntive": "Nota aggiuntiva",
            "iniziativeControSoggettoSegnalato": ""
        }
    },
    "documentazioneAllegata": {
        "documentiAllegati": []
    },
    "systemInformations": {
        "type": "STOR",
        "state": "IN_COMPILAZIONE",
        "identificativo": "2022_0001",
        "id": 1
    }
}



// const SegnalazioneMockInCompilazione =  {
//     "id": "2022_001",
//     "protocolNumber": "",
//     "suspicionReason": "test",
//     "suspicionType": {
//       "id": 1,
//       "rank": 1,
//       "name": "Tentato Insider trading"
//     },
//     "sentDate": "",
//     "notes": "string",
//     "reportedSubjectInitiatives": "string",
//     "reportingSubject": {
//       "id": 1,
//       "name": "Alessandra Cailli",
//       "notes": "",
//       "legalForm": {
//         "id": 1,
//         "rank": 1,
//         "name": "SPA",
//         "validFrom": "2022-03-18",
//         "validTo": "",
//         "usable": true,
//         "description": "SOCIETA' PER AZIONI",
//         "anagraphKey": 6
//       },
//       "leiCode": "0000",
//       "address": {
//         "id": 1,
//         "address": "Via col vento",
//         "buildingNumber": "96",
//         "zipCode": "70100",
//         "country": {
//           "id": 127,
//           "rank": 1,
//           "name": "Italy",
//           "phoneCode": "39",
//           "iso2": "IT",
//           "iso3": "ITA"
//         },
//         "city": "Bari",
//         "region": "Puglia",
//         "province": "Bari"
//       },
//       "relationshipDescription": "string",
//       "creationTime": "2022-11-14T17:17:00.369879",
//       "lastUpdateTime": "2022-11-14T17:17:00.369892",
//       "reportingSubjectType": {
//         "id": 1,
//         "rank": 1,
//         "name": "Banca",
//         "validFrom": "",
//         "validTo": "",
//         "usable": false,
//         "anagraphKey": ""
//       },
//       "reportingSubjectRole": {
//         "id": 1,
//         "rank": 1,
//         "name": "Intermediario - C/terzi"
//       },
//       "negotiatedActivityType": {
//         "id": 1,
//         "rank": 1,
//         "name": "Market Making"
//       },
//       "negotiatedInstrumentType": {
//         "id": 1,
//         "rank": 1,
//         "name": "Azioni"
//       },
//       "negotiatedActivityKind": {
//         "id": 1,
//         "rank": 1,
//         "name": "Market Making"
//       }
//     },
//     "naturalPerson": {
//       "id": 1,
//       "surname": "Cailli",
//       "name": "Alessandra",
//       "phoneNumber1": "099898724024",
//       "phoneNumber2": "3423428749",
//       "position": "-",
//       "email": "",
//       "createdOn": "2022-11-14T17:17:00.193498",
//       "updatedOn": "2022-11-14T17:17:00.193523"
//     },
//     "state": {
//       "id": 1,
//       "rank": 1,
//       "name": "In compilazione"
//     },
//     "moreInfoContacts": [
//       {
//         "id": 1,
//         "surname": "Marco",
//         "name": "Giardina",
//         "email": "marcogiardina@giardinamarco.com",
//         "position": "",
//         "creationTime": "2022-11-14T17:17:00.720016",
//         "lastUpdateTime": "2022-11-14T17:17:00.720034"
//       },
//       {
//         "id": 21,
//         "surname": "Rossi",
//         "name": "Mario",
//         "email": "mariorossi@email.tld",
//         "position": "",
//         "creationTime": "2022-11-14T17:17:00.720016",
//         "lastUpdateTime": "2022-11-14T17:17:00.720034"
//       }
//     ],
//     "financialInstruments": [
//       {
//         "id": 1,
//         "code": "695984651",
//         "subCode": "695984651",
//         "description": "Operazione molto sospetta",
//         "cfiCode": "CFI1",
//         "subCfiCode": "CFI2",
//         "cfiType": "CFI_Type",
//         "subCfiType": "",
//         "trandingVenueCode": "",
//         "tradingVenueName": "string",
//         "contractTerms": "string",
//         "subDescription": "string",
//         "size": "string",
//         "offsite": true,
//         "amount": 12000,
//         "margin": 0,
//         "name": "Operazione tanto sospetta",
//         "prepayment": 0,
//         "premium": 0,
//         "strikePrice": 0,
//         "interestRate": 0,
//         "otcDerivedType": "string",
//         "nominalValue": 0,
//         "currency": {
//           "id": 1,
//           "rank": 1,
//           "name": "EURO"
//         },
//         "expireDate": "2024-12-03T01:04:41.000+00:00",
//         "createdOn": "2022-11-14T17:17:00.629767",
//         "updatedOn": "2022-11-14T17:17:00.62979",
//         "orderDate": {
//           "id": 1,
//           "end": "2022-03-10T00:00:00.000+00:00",
//           "start": "2022-03-10T00:00:00.000+00:00",
//           "creationTime": "2022-11-14T17:17:00.485083",
//           "lastUpdateTime": "2022-11-14T17:17:00.847934",
//           "timeZone": {
//             "id": 1,
//             "rank": 1,
//             "name": "GMT (Greenwich Mean Time)",
//             "code": "GMT",
//             "offset": 0
//           }
//         },
//         "orderDescription": [],
//         "orderLocation": {
//           "id": 1,
//           "countryCreated": {
//             "id": 2,
//             "rank": 1,
//             "name": "Cameroon",
//             "phoneCode": "237",
//             "iso2": "CM",
//             "iso3": "CMR"
//           },
//           "countryExecuted": {
//             "id": 3,
//             "rank": 1,
//             "name": "Cayman Islands",
//             "phoneCode": "1345",
//             "iso2": "KY",
//             "iso3": "CYM"
//           },
//           "createdOn": "2022-11-14T17:17:00.57001",
//           "updatedOn": "2022-11-14T17:17:00.873224"
//         }
//       }
//     ],
//     "userId": "39d14565-fc6f-40a2-baea-7b881f7133e2",
//     "createdOn": "2022-11-14T17:17:00.439566",
//     "updatedOn": "2022-11-14T17:17:00.439579",
//     "type": {
//       "id": 1,
//       "rank": 1,
//       "name": "STORs - Internal"
//     },
//     "suspects": [],
//     "attachments": []
//  }
export default SegnalazioneMockInCompilazione;